import { render, staticRenderFns } from "./AramaStats.vue?vue&type=template&id=1c816ee0"
import script from "./AramaStats.vue?vue&type=script&lang=js"
export * from "./AramaStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports